import { FC, useState } from "react"
import { RotationRightButton } from "../../../../components/buttons/iconButtons/action/RotationCollection"
import BaseCommandsPanel from "../../../../components/commandsPanels/BaseCommandsPanel"
import { checkActiveCommands } from "../../../CommonHelperFunctions"
import { useUserContext } from "../../../../system/providers/userContextProvider"
import { DatePeriodPanel } from "../../../../hoc/DatePeriodPanel/DatePeriodPanel"
import { DateTime } from "luxon"
import { IDatePeriod } from "../../../../components/datePeriodPicker/datePeriodPicker"
import { GridFilterAction } from "../../../../system/hooks/useGridFilter"
import { useTranslation } from "react-i18next"
import Tooltip from "../../../../components/tooltips/Tooltip"
import InputSearch from "../../../../components/inputSearch/inputSearch"

interface IPanelEvent {
    disabled?: boolean;
    onClick: () => any;
    onSubItemClick?: () => any;
}

interface IFalsificatPanelProps {
    refresh?: IPanelEvent;
    permission?: IPermission;
    gridFilter: IGridFilter;
    dispatchGridFilter: (value: GridFilterAction) => void;
    isModal?: boolean;
    onFocusChanged?: (taken: boolean) => void;
}

export const FalsificatPanel: FC<IFalsificatPanelProps> = (props) => {
    const userContext = useUserContext();
    const activeCommands = checkActiveCommands(props.permission as IPermission, userContext.userPermission);
    const { t } = useTranslation();
    const DefaultDatePeriod = { startDate: DateTime.now().plus({ days: -7 }), endDate: DateTime.now() } as IDatePeriod;
    const [datePeriod, setDatePeriod] = useState<IDatePeriod>(DefaultDatePeriod);
    const [searchValue] = useState<string>('');

    const baseExpression = `lower("GoodsName") like lower('%%SEARCH_VALUE%%') or lower("Seria") like lower('%%SEARCH_VALUE%%')`;

    return (<>
        <BaseCommandsPanel groups={[
            [
                {
                    iconButton: <Tooltip title={'Обновить'}>
                        <RotationRightButton sizeVariant="mini"  {
                            ...{
                                ...props.refresh,
                                disabled: props.refresh?.disabled || !activeCommands.refresh,
                            }
                        } />
                    </Tooltip>
                }
            ]
        ]} />
        <div style={{ marginRight: 10, alignSelf: 'center', marginTop: 5 }}>
            <InputSearch
                searchValue={searchValue}
                placeholder={t("directory.falsificat.search")}
                typeFilter={"expression"}
                filterName={baseExpression}
                gridFilter={props.gridFilter}
                dispatchGridFilter={props.dispatchGridFilter}
            />
        </div>
        <DatePeriodPanel
            datePeriod={datePeriod}
            onDatePeriodChange={(date: IDatePeriod) => {
                setDatePeriod(date);
                props.dispatchGridFilter({
                    type: "sortByFilters",
                    payload: {
                        gridColumnFilter: [
                            ...(date?.startDate
                                ? [
                                    {
                                        name: "documentDate",
                                        value: date.startDate.toFormat("yyyyMMdd"),
                                        operator: "MoreOrEq",
                                    } as IGridColumnFilter,
                                ]
                                : []),
                            ...(date?.endDate
                                ? [
                                    {
                                        name: "documentDate",
                                        value: date.endDate.toFormat("yyyyMMdd"),
                                        operator: "LessOrEq",
                                    } as IGridColumnFilter,
                                ]
                                : []),
                        ],
                    },
                });
            }}
        />
    </>)
}